/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadInteractionTyeFromJSON, ApiLeadInteractionTyeToJSON, } from './ApiLeadInteractionTye';
import { ApiLeadStatusFromJSON, ApiLeadStatusToJSON, } from './ApiLeadStatus';
export function ApiLeadInteractionFromJSON(json) {
    return ApiLeadInteractionFromJSONTyped(json, false);
}
export function ApiLeadInteractionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'leadStatusId': !exists(json, 'leadStatusId') ? undefined : json['leadStatusId'],
        'status': !exists(json, 'status') ? undefined : ApiLeadStatusFromJSON(json['status']),
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'type': !exists(json, 'type') ? undefined : ApiLeadInteractionTyeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadInteractionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'leadStatusId': value.leadStatusId,
        'status': ApiLeadStatusToJSON(value.status),
        'subject': value.subject,
        'type': ApiLeadInteractionTyeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
